export const FT_EVOUCHERS = 'ldt_evouchers';
export const FT_TPM_BY_DESIGN = 'ldt_tpm_for_byd';
export const FT_TPM_BILLTO_CCMSV2 = 'ldt_tpm_hdms_billto_ccmsv2';
export const FT_HDMS_CCMSV2 = 'ldt_hdms_ccmsv2';
export const FT_NGC_TOKEN_SERVICE_WORKER = 'ldt_ngc_token_service_worker';
export const FT_GLOBAL_AUTHORIZATION_MANAGEMENT = 'ldt_global_authorization_management';
export const FT_HDMS_CCMSV2_FLEET_ACCOUNT = 'ldt_hdms_ccmsv2_fleet_account';
export const FT_NGC_GRAPHQL_ACCOUNTS = 'ldt_ngc_graphql_accounts';
export const FT_EXCHANGE_SHIPTO_CCMSV2 = 'ldt_tpm_hdms_shipto_ccmsv2';
export const FT_KUNA_DISABLED = 'ldt_kuna_disabled';
